import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CYComponent } from '@modules/cy/pages/cy/cy.component';
import { physicianGuard } from '@app/auth/guards/physician.guard';
import { TestComponent } from '@modules/test/test.component';
import { PatientComponent } from '@modules/cy/patient/pages/patient/patient.component';
import { PSroutes } from '@modules/cy/patient/ps/ps-routing.module';

export const patientRoutes: Routes = [
  {
    path: '',
    component: CYComponent,
    canActivate: [physicianGuard],
  },
  {
    path: 'patient',
    component: PatientComponent,
    canActivate: [physicianGuard],
    children: PSroutes,
  },
  {
    path: '**',
    redirectTo: '/cy',
  },
];

@NgModule({
  imports: [RouterModule.forChild(patientRoutes)],
  exports: [RouterModule],
})
export class PatientRoutingModule {}
